import { Link, useSearchParams } from 'react-router-dom'
import { Form, Formik } from 'formik'
import { Box, Button, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'

import { AppVersion, AuthFormWrapper, HelperWrapper } from 'src/components'
import { SignupFinishForm } from './sign-up-finish-form.component'
import { useFinsihUserSignup } from 'src/hooks'
import { TrackgoodLogo } from 'src/assets/icons'

import { ROUTES } from 'src/constants'
import { finishSignupSchema } from 'src/common/validations'
import { useStyles } from '../styles'
import { IFinishUserSignup } from 'src/types'
import { getEncodedQueryParam } from 'src/common/utils'

const SignupFinish = () => {
  const theme = useTheme()
  const [searchParams] = useSearchParams()
  const { mutateAsync: finishRegistration } = useFinsihUserSignup()

  const email = getEncodedQueryParam('email')
  const withoutAccount = searchParams.get('without_account')
  const withPassword = searchParams.get('with_password')

  const classes = useStyles()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile_s'))

  const handleSubmit = async ({ account_holder, ...values }: IFinishUserSignup) => {
    return withoutAccount || !values.buisness
      ? await finishRegistration(values)
      : await finishRegistration({ ...values, account_holder })
  }

  return (
    <Grid item xs={isLaptop ? 12 : 6} className={classes.contentWrapper}>
      <Grid
        display={isLaptop ? 'none' : 'flex'}
        justifyContent="flex-end"
        className={classes.signUpContainer}
      >
        <Typography className={classes.textSignUp} alignItems={'center'}>
          <HelperWrapper t="sign-in-email-opposite-text" />{' '}
          <Link style={{ textDecoration: 'none' }} to={ROUTES.LOGIN}>
            <Button className={classes.buttonSignUp}>
              <HelperWrapper t="login-link-text" />
            </Button>
          </Link>
        </Typography>
      </Grid>
      <AuthFormWrapper>
        <Box
          sx={{
            width: isMobile ? '90vw' : isTablet ? '300px' : isLaptop ? '500px' : '350px',
            display: 'flex',
            gap: '10px',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '20px',
            }}
          >
            <TrackgoodLogo />
          </div>

          <Typography
            sx={{
              fontSize: isMobile ? '20px' : '24px',
              fontWeight: 700,
              margin: '0px',
              textAlign: 'center',
              padding: '20px 5px',
              width: '100%',
            }}
          >
            <HelperWrapper t="register-agreement-title-text" />
          </Typography>

          <Formik
            initialValues={{
              password: withPassword ? '' : null,
              account_holder: '',
              agreement: false,
              email: email ?? '',
              buisness: false,
            }}
            autoComplete="off"
            onSubmit={handleSubmit}
            validationSchema={finishSignupSchema(!!email, !!withoutAccount, !!withPassword)}
          >
            <Form>
              <SignupFinishForm />
            </Form>
          </Formik>
        </Box>
      </AuthFormWrapper>
      <footer className={classes.footerWrapper}>
        <AppVersion />
      </footer>
    </Grid>
  )
}

export { SignupFinish }
